import { ParamTypes } from "src/pages/DataAssets/views/Expectations/Expectation/Expectation"

export type ParameterSourceType = "fixed" | "dynamic" | "forecast"

/**
 * Determines the source type of expectation parameters
 * @param params - The parsed expectation parameters
 * @param kwargs - Optional kwargs string for additional windowed parameter detection
 * @returns The parameter source type
 */
export function detectParameterSource(params: ParamTypes, kwargs?: string): ParameterSourceType {
  if (isForecastParameters(params)) {
    return "forecast"
  }

  if (isDynamicParameters(params, kwargs)) {
    return "dynamic"
  }

  return "fixed"
}

/**
 * Checks if parameters indicate forecast-managed expectations
 * Forecast expectations are identified by constraint_fn = "forecast"
 */
function isForecastParameters(params: ParamTypes): boolean {
  return "constraint_fn" in params && params.constraint_fn?.value === "forecast"
}

/**
 * Checks if parameters indicate Dynamic Parameter expectations
 * Dynamic parameters are identified by:
 * - constraint_fn present with values not "forecast"
 * - windowed parameters in kwargs
 */
function isDynamicParameters(params: ParamTypes, kwargs?: string): boolean {
  if ("constraint_fn" in params && params.constraint_fn?.value === "mean") {
    return true
  }

  if (kwargs) {
    try {
      const parsedKwargs = JSON.parse(kwargs)
      if ("windows" in parsedKwargs && Array.isArray(parsedKwargs.windows) && parsedKwargs.windows.length > 0) {
        return true
      }
    } catch {
      // If kwargs parsing fails, fall back to fixed
    }
  }

  return false
}
